import ProductSearchService from "../Services/Search/ProductSearchService";

export default class ProductSearch {

    main() {
        ProductSearchService.init();
    }

}